import React from "react"
import ArtistDetailText from "../../../components/ArtistDetailText"

const DetailCv = ({ user: { cv } = {} }) => <ArtistDetailText text={cv} />

export default DetailCv
